import { Position } from './position.model';

export class MarkerClusterFind {

    public showOnMapRequestId: string;
    public location: Position;

    constructor(obj: Partial<MarkerClusterFind>) {
        Object.assign(this, obj);
    }

}
